<mat-form-field
  class="datepicker"
  [disabled]="disabled"
  [appearance]="appearance"
  [style.width.%]="width || 100"
>
  <mat-label *ngIf="isFloatingLabel && placeholder" [show]="placeholder">
    <span>{{ placeholder }}</span>
  </mat-label>
  <input
    [attr.data-cy]="data_cy"
    matInput
    [matDatepicker]="picker1"
    [min]="minDateValidation"
    [max]="maxDateValidation"
    placeholder="{{ placeholder || '' }}"
    [value]="date == minDate ? null : date"
    (dateChange)="change($event.value)"
    (click)="picker1.open()"
    [disabled]="disabled"
    [readonly]="readOnly"
  />
  <mat-datepicker-toggle
    matSuffix
    [for]="picker1"
    [style.display]="displayToggle ? 'unset' : 'none'"
  >
  </mat-datepicker-toggle>
  <mat-datepicker
    (opened)="onOpenDatepicker()"
    (closed)="onCloseDatepicker()"
    #picker1
    [calendarHeaderComponent]="headerComponent"
  ></mat-datepicker>
</mat-form-field>
